import { IFormEditorType } from "../../../models/response/form/IFormEditorType";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const objFormEditorTypeDefine = {
    LOAD_START: "",
    LOAD_SUCCESS: [] as IFormEditorType[],
    LOAD_ERROR: ""
};

export const eFormEditorTypeActionTypeIds = generateActionTypeIds(objFormEditorTypeDefine, "FORM_EDITOR_TYPE")
export type IFormEditorTypeActionTypes = IGenericActionType<typeof objFormEditorTypeDefine, "FORM_EDITOR_TYPE">
